import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
let store = new Vuex.Store({
    state: {
        terminalData: [], //终端流量来源
        orderData: [], //订单来源数据
        repurchaseData: [], //用户复购数据
        productData: [], //热销商品
        productList: [], //热销商品列表---更改为新增订单
        citySaleData: [], //省份销售排行
        cityShopData: [], //省份酒店数
        chinaMapDataOn: [], //在线设备
        isMapChange: false,//设备数据是否改变
        otherData: {}, //非表类数据
        phoneData:[], //用户画像
        sanData:[],
        feiData:[],
        timeData:[]
    },
    getters: {
        getState: (state) => (name) => {
            return state[name];
        }
    },
    mutations: {
        updateState: (state, params) => {
            state[params.name] = params.data;
        }
    },
    actions: {
        updateCommit: ({ commit }, params) => {
            commit('updateState', params);
        }
    }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js